export const SC_CONTENT = {
  hero: {
    kicker: 'Para empresas que vendem produtos',
    title: 'Seu estoque pode estar fazendo você perder vendas todos os dias.',
    subtitle:
      'Tenha controle total do que entra, sai e precisa ser reposto — sem planilhas e sem erro. Decisão com base em dados, não no achismo.',
    cta: 'Quero parar de perder vendas',
    ctaMessage: 'Quero conhecer o controle de estoque do 77Gestão',
    urgency: 'Enquanto você decide, vendas continuam sendo perdidas por falta de produto.',
  },

  statsStrip: [
    { number: 'Tempo real', label: 'visibilidade do estoque', icon: 'fa-solid fa-eye' },
    { number: 'Zero', label: 'surpresas com ruptura de estoque', icon: 'fa-solid fa-triangle-exclamation' },
    { number: '1 lugar', label: 'para controlar tudo', icon: 'fa-solid fa-warehouse' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então você sabe que algo precisa mudar.',
    intro:
      'Empresas que trabalham com produtos perdem dinheiro todos os dias por causa de estoque descontrolado. Não é falta de esforço — é falta da ferramenta certa.',
    items: [
      { icon: 'fa-solid fa-box-open', text: 'Produto acaba e você só descobre quando o cliente reclama ou a venda já foi perdida.' },
      { icon: 'fa-solid fa-boxes-stacked', text: 'Estoque não bate com a realidade: sobra de um lado, falta do outro.' },
      { icon: 'fa-solid fa-cart-flatbed', text: 'Você não sabe o que precisa comprar — compra no achismo e erra.' },
      { icon: 'fa-solid fa-coins', text: 'Capital preso em mercadoria parada que não tem giro.' },
      { icon: 'fa-solid fa-rotate', text: 'Informações espalhadas entre planilhas, WhatsApp e cadernos.' },
      { icon: 'fa-regular fa-clock', text: 'Tempo perdido contando estoque na mão e atualizando planilha toda semana.' },
      { icon: 'fa-solid fa-chart-line', text: 'Sem visibilidade do giro: você não sabe quais produtos vendem e quais ficam parados.' },
      { icon: 'fa-solid fa-triangle-exclamation', text: 'Erros operacionais que viram devolução, reclamação e dor de cabeça.' },
    ],
  },

  midCta: {
    text: 'E se você pudesse saber agora o que está acabando, o que está parado e o que precisa comprar?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do controle de estoque do 77Gestão',
  },

  solution: {
    title: 'Mais controle não significa mais trabalho. Significa ter um sistema que faz isso por você.',
    intro:
      'O módulo de estoque do 77Gestão foi pensado para quem vende produtos e precisa de previsibilidade real — sem complicação.',
    cards: [
      {
        icon: 'fa-solid fa-warehouse',
        title: 'Visibilidade em tempo real',
        text: 'Saiba exatamente o que tem disponível, em qual depósito e em qual estado. Sem precisar contar na mão.',
      },
      {
        icon: 'fa-solid fa-bell',
        title: 'Alertas de reposição',
        text: 'Configure o estoque mínimo de cada produto e receba alertas antes de acabar — nunca mais perca venda por ruptura.',
      },
      {
        icon: 'fa-solid fa-magnifying-glass-chart',
        title: 'Giro de estoque visível',
        text: 'Identifique rapidamente quais produtos vendem bem e quais estão parados. Compre com base em dados, não em intuição.',
      },
      {
        icon: 'fa-solid fa-truck-ramp-box',
        title: 'Entradas e saídas controladas',
        text: 'Registre compras, devoluções e movimentações de forma simples. O sistema atualiza tudo automaticamente.',
      },
      {
        icon: 'fa-solid fa-store',
        title: 'Catálogo público de produtos',
        text: 'Compartilhe seu catálogo com clientes com preços, fotos e disponibilidade sempre atualizados — sem depender de vendedor para responder.',
      },
      {
        icon: 'fa-solid fa-layer-group',
        title: 'Integrado com vendas e financeiro',
        text: 'Cada venda dá baixa no estoque automaticamente. Financeiro, estoque e NF-e em um único sistema.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando uma empresa para de operar no achismo',
    intro:
      'Uma empresa com venda mista de produtos e serviços controlava o estoque em planilhas. O dono só descobria a ruptura quando o cliente ligava reclamando.',
    stats: [
      { number: '0', label: 'rupturas não previstas após o sistema' },
      { number: '3x', label: 'mais rápido para fechar pedidos de compra' },
      { number: '100%', label: 'de visibilidade do estoque em tempo real' },
    ],
    paragraphs: [
      'Após a implantação acompanhada, o estoque passou a ser gerenciado em tempo real — com alertas automáticos de reposição e visibilidade de giro por produto.',
      'O resultado foi imediato: menos capital preso em produtos parados e nenhuma venda perdida por falta de estoque nos meses seguintes.',
    ],
    highlight: 'Resultado: controle real, menos desperdício e zero surpresas com ruptura.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o resultado e quero entender como ter controle de estoque real no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão de estoque',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Saldo de estoque, giro, alertas e movimentações disponíveis a qualquer momento — não só quando você conta na mão.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Cada entrada, saída e devolução registrada. Você sabe exatamente o que tem e o que precisa comprar.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Alertas de reposição e análise de giro que antecipam a falta. Você age antes de perder a venda.',
      },
    ],
  },

  comparison: {
    title: 'Planilha vs. Sistema: a diferença na prática',
    items: [
      {
        problem: 'Planilha desatualizada',
        solution: 'Estoque atualizado em tempo real a cada venda ou entrada',
      },
      {
        problem: 'Ruptura descoberta quando o cliente reclama',
        solution: 'Alerta automático quando o produto chega no estoque mínimo',
      },
      {
        problem: 'Compra no achismo',
        solution: 'Decisão de compra apoiada em relatório real de mais/menos vendidos',
      },
      {
        problem: 'Capital preso em produto parado',
        solution: 'Visibilidade do que não tem giro para ajustar mix e compras',
      },
      {
        problem: 'Informação espalhada em vários lugares',
        solution: 'Tudo em um único sistema integrado com vendas e financeiro',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para controlar o estoque',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema simples, adaptável ao tamanho e ao tipo da sua operação.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: você não começa sozinho.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
      { icon: 'fa-solid fa-link', text: 'Estoque integrado com vendas, financeiro e NF-e — um lançamento alimenta tudo.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Minha operação é complexa. O sistema consegue acompanhar?',
        answer:
          'Sim. O sistema é adaptável ao tamanho e ao tipo da sua operação — seja e-commerce, distribuidor ou venda mista. A implantação é acompanhada para configurar tudo do jeito que a sua empresa funciona.',
      },
      {
        question: 'Não tenho tempo para implementar.',
        answer:
          'Você não precisa fazer sozinho. A equipe acompanha todo o processo de implantação, no seu ritmo, sem parar a operação. A maioria dos clientes começa a ver resultado em poucos dias.',
      },
      {
        question: 'Já tentei outros sistemas e não funcionou.',
        answer:
          'A diferença está na implantação acompanhada e no suporte humano. Não é só acesso ao sistema — é configuração, treinamento e acompanhamento até você ter controle real.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de operar no escuro. Tenha controle real do seu estoque.',
    subtitle:
      'Agende sua demonstração e veja, na prática, como evitar ruptura, reduzir capital parado e tomar decisões com base em dados reais.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do controle de estoque do 77Gestão',
  },

  seo: {
    title: 'Sistema de Controle de Estoque para E-commerce e Distribuidores | 77Gestão',
    description:
      'Controle de estoque em tempo real para e-commerce, distribuidores e venda mista. Alertas de reposição, giro de produtos e integração com vendas e financeiro. Agende uma demonstração.',
  },
};
